<template>
    <div>
        <v-dialog v-model="isVisible" width="400" persistent>
            <v-card>
                <v-btn icon @click="closeModal" style="position: absolute; right: 0; top: 0;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="text-h5 justify-content-center" style="padding-top: 50px;">
                    {{ esExtranjero() ? 'Credit bureau approval' : 'Aprobación de buró de crédito' }}
                </v-card-title>
                <v-card-text v-if="esExtranjero()">
                    <b class="text-dark">Scan the QR code with your smartphone</b><br>
                    start your identify validation.
                </v-card-text>
                <v-card-text v-else>
                    <b class="text-dark">Escanea el código QR con tu dispositivo móvil</b><br>
                    para iniciar la validación de tu identidad.
                </v-card-text>
                <QrcodeVue :value="urlToCopy" size="150" level="H" class="p-4"></QrcodeVue>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import QrcodeVue from 'qrcode.vue';
import servicios from "../../../servicios/service.js";

export default {
    components: {
        QrcodeVue
    },
    props: {
        modalActivo: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            urlToCopy: window.location.origin + '/LoginMaster?preonboarding=true',
            isVisible: this.modalActivo
        };
    },
    watch: {
        modalActivo(newVal) {
            this.isVisible = newVal;
        }
    },
    methods: {
        closeModal() {
            this.isVisible = false;
            this.$emit("modalClosed"); // Emitir el evento modalClosed
        },
        modalInput(value) {
            this.isVisible = value; // Actualiza la variable isVisible
        },
        esExtranjero() {
            return servicios.esExtranjero(this.$store.getters.tipoPersona);
        }
    }
};
</script>
  
<style lang="scss" scoped></style>
  